import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { responsive } from "../../utils/style";

const SelectLabel = styled.span`
  size: 21px;
`;

const SelectContainer = styled.div`
  max-width: 1144px;
  width: 440px;

  ${responsive.mobile(css`
    max-width: 375px;
    padding-left: 8px;
    padding-right: 8px;
  `)}
`;

const TotalScoreContainer = styled.div`
  width: 100%;
  height: 140px;
  background: #a3eae1;
  margin-top: 24px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${responsive.tablet(css`
    max-width: 834px;
    margin-left: 32px;
    margin-right: 32px;
  `)}

  ${responsive.mobile(css`
    width: 100%;
    max-width: 375px;
    margin-left: 0px;
    margin-right: 0px;
  `)}
`;

const ReportsContainer = styled.div`
  margin-bottom: 24px;
  width: 100%;
`;

export { SelectLabel, SelectContainer, TotalScoreContainer, ReportsContainer };
